import { SubscriptionMethodTypes, AttendanceStatusTypes } from '../../domain/training.event.subscription';

export class AddTrainingEventSubscriptionRequest {
    SubscriptionMethodType: SubscriptionMethodTypes;
    AttendanceStatusType: AttendanceStatusTypes;
    SubscriptionNotes: string;
    AlternatePhone: string;
    AlternateEmail: string;
    License_ID: number;
}

export class AddTrainingEventSubscriptionRequestArray extends Array<AddTrainingEventSubscriptionRequest> {
    constructor(...items: AddTrainingEventSubscriptionRequest[]) {
        super(...items);
        Object.setPrototypeOf(this, AddTrainingEventSubscriptionRequestArray.prototype);
    }
}
